import { render } from "./OptionsVisits.vue?vue&type=template&id=5a7854cd"
import script from "./OptionsVisits.vue?vue&type=script&lang=js"
export * from "./OptionsVisits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__